<template>
  <v-card flat pa-1 id="card-question-filter">
    <v-form @submit.prevent="getFilteredMock">
      <v-container style="padding: 12px 0px">
        <v-flex fluid wrap>
          <v-flex ma-0 pa-0 sm12 xs12>
            <v-row align="center">
              <v-col class="d-flex" cols="12" sm="4">
                <v-autocomplete
                  :disabled="isUpdating"
                  :error-messages="errors.collect('curso')"
                  :items="courses"
                  :v-errors="errors"
                  @change="onCourseChanged"
                  small-small-chips
                  clearable
                  hide-details
                  outlined
                  required
                  data-vv-name="curso"
                  item-text="course"
                  item-value="id"
                  label="Curso"
                  v-model="filter.courseId"
                  v-validate="'required'"
                  :loading="isUpdating"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="d-flex" cols="12" sm="4">
                <v-autocomplete
                  :disabled="isUpdating"
                  :items="topics"
                  @change="onTopicsChanged"
                  small-chips
                  clearable
                  hide-details
                  item-text="topic"
                  item-value="id"
                  label="Módulos / Disciplinas"
                  multiple
                  outlined
                  hide-selected
                  v-model="filter.topics"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Não há dados </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="d-flex" cols="12" sm="4">
                <v-autocomplete
                  :disabled="isUpdating"
                  :items="subjects"
                  small-chips
                  clearable
                  hide-details
                  item-text="subject"
                  item-value="id"
                  label="Assuntos"
                  multiple
                  outlined
                  hide-selected
                  v-model="filter.subjects"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Não há dados </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-flex>
          <v-flex ma-0 mt-3 pa-0 sm12 xs12>
            <v-row align="center" pa-0>
              <v-col class="d-flex" cols="12" sm="8" pa-0>
                <v-text-field
                  :disabled="isUpdating"
                  clearable
                  hide-details
                  label="Número ou Conteúdo"
                  outlined
                  v-model="filter.content"
                >
                </v-text-field>
              </v-col>
              <v-col class="d-flex" cols="12" sm="4" pa-0>
                <v-select
                  :items="this.limitItems"
                  item-text="text"
                  item-value="value"
                  label="máximo de questões"
                  outlined
                  hide-details
                  v-model="filter.limit"
                />
              </v-col>
            </v-row>
          </v-flex>
          <v-flex ma-0 mt-3 pa-0 sm12 xs12>
            <v-row align="baseline">
              <v-col class="d-flex" cols="12" sm="7">
                <v-select
                  :items="this.mockResolutionModes"
                  item-text="text"
                  item-value="value"
                  label="Modo de resolução"
                  outlined
                  hide-details
                  required
                  :error-messages="errors.collect('modo de resolução')"
                  :v-errors="errors"
                  small-chips
                  v-model="filter.mode"
                  :hint="
                    filter.mode === 1
                      ? 'permite corrigir questões individualmente'
                      : 'correção e feedback apenas ao finalizar o simulado'
                  "
                >
                  <template v-slot:selection="i">
                    <v-chip :key="i.item.value" :input-value="i.item.text">
                      <v-icon v-if="i.item.value === 1" class="ma-1">
                        fitness_center
                      </v-icon>
                      <v-icon v-else class="ma-1"> grading </v-icon>
                      {{ i.item.text }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col class="d-flex" cols="12" sm="5">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-switch
                      class="ma-0"
                      label="Questões que não resolvi"
                      v-model="filter.neverSolved"
                      v-on="on"
                    ></v-switch>
                  </template>
                  <span
                    >Se marcado, exibirá apenas questões que você nunca resolveu
                    antes</span
                  >
                </v-tooltip>
              </v-col>
            </v-row>
          </v-flex>
          <v-row>
            <v-col cols="12">
              <v-btn
                :loading="isUpdating"
                @click="getFilteredMock"
                color="primary"
                rounded
                elevation="0"
                depressed
              >
                <v-icon left>search</v-icon>
                Pesquisar
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import CourseService from "../../services/courses.service";
import TopicService from "../../services/topics.service";
import SubjectService from "../../services/subjects.service";

export default {
  $_veeValidate: {
    validator: "new",
  },
  data() {
    return {
      isUpdating: false,
      dialog: false,
      courses: [],
      topics: [],
      subjects: [],
      filter: {
        limit: 50,
        neverSolved: false,
        mode: 1,
      },
      limitItems: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "150", value: 150 },
      ],
      mockResolutionModes: [
        { text: "Simulação", value: 2 },
        { text: "Treino", value: 1 },
      ],
    };
  },
  created() {
    this.loadCourses();
  },
  methods: {
    getFilteredMock() {
      this.formHasErrors().then((hasError) => {
        console.log(hasError);
        if (!hasError) {
          this.isUpdating = true;
          this.$emit("filter", this.filter, {
            courses: this.courses,
            topics: this.topics,
            subjects: this.subjects,
          });
          this.isUpdating = false;
          this.dialog = false;
        } else {
          console.log(hasError);
        }
      });
    },
    loadCourses() {
      CourseService.getCertificationCourses({
        search: 1,
        searchFields: "type_id:=",
      }).then((response) => {
        this.courses = response.data;
      });
    },
    loadTopics(courseId) {
      this.isUpdating = true;
      TopicService.getListPublic({
        inQuestions: 1,
        courseId: courseId,
        orderBy: "topic",
      }).then((response) => {
        this.topics = response.data;
        this.isUpdating = false;
      });
    },
    loadSubjects(courseId) {
      this.isUpdating = true;
      SubjectService.getListPublic({ inQuestions: 1, courseId: courseId }).then(
        (response) => {
          this.subjects = response.data;
          this.isUpdating = false;
        },
      );
    },
    onCourseChanged(courseId) {
      // console.log('changed', e)
      this.filter.topics = [];
      this.filter.subjects = [];
      this.loadTopics(courseId);
      this.loadSubjects(courseId);
    },
    onTopicsChanged() {
      // console.log('changed', e)
    },
  },
};
</script>

<style>
.theme--dark.v-card#card-question-filter {
  background: transparent !important;
}
</style>
